import { useContext } from "react";

import TestClasses from '../Tests/Test.module.css';
import { NavLink } from "react-router-dom";

const NORDX_Header = () => {

    return (
        <div className={TestClasses.buttonArea2}>
			<button className={TestClasses.buttonDarkBlue}>FAQS</button> <button className={TestClasses.buttonDarkBlue}> How to Read Results </button><button className={TestClasses.buttonDarkBlue}> Physician Support </button>
        </div>
    );
};

export default NORDX_Header;